/*Linkify hyperlinks*/

const pattern = /((https?:\/{2}|w{3}\.)[a-zA-Z0-9]+\.[\/\S]+)/ig;

const noFollowList = [
    'theasianparent.com',
    'herstyleasia.com',
    'asianmoneyguide.com',
    'tickledmedia.com',
    'nonilo.com'
];

const Linkify = (contentStr) => {
    return contentStr.replace(pattern, (match, p1, p2) => {
        let ifNoFollow = true;
        //check for domain
        for(const k in noFollowList) {
            if(match.indexOf(noFollowList[k]) > -1) {
                ifNoFollow = false;
                break;
            }
        }
        const noFollowString = ifNoFollow ? "rel='nofollow'" : "";
        let replacement = match;
        if(match.indexOf('>') === -1){ // check no anchor tag
            if(p2.indexOf('http') > -1) {
                replacement = `<a href='${p1}' target='_blank' ${noFollowString}>${p1}</a> `;
            } else if(p2.indexOf('www') > -1) {
                replacement = `<a href='http://${p1}' target='_blank' ${noFollowString}>${p1}</a> `;
            }
        }
        else{
            replacement = match.indexOf('target') === -1 ? replacement.replace('>', 'target="_blank">') : replacement;
            replacement = match.indexOf('nofollow') === -1 ? replacement.replace('>', ` ${noFollowString}>`) : replacement;
        }
        return replacement;
    });
}

export default Linkify;